import VeridocIcon from "../../assets/img/veridoc";
import VerifaceIcon from "../../assets/img/veriface";
import VeriliveIcon from "../../assets/img/verilive";


export function getObservableParams(service_name) {

    if (service_name === "veridoc") {
        return [
            "num_transactions",
            "num_successful_transactions",
            "num_failed_transactions"
        ];
    }

    if (service_name === "veriface") {
        return [
            "num_transactions",
            "num_successful_transactions",
            "num_failed_transactions"
        ];
    }

    if (service_name === "verilive") {
        return [
            "num_transactions",
            "num_transactions_attack",
            "num_transactions_real",
            "num_transactions_unfinished"
        ];
    }

    return [];
}

export function getQualifiedParamName(param) {

    const qualifiedParamNameMap = {
        "num_transactions": "Total transactions",
        "num_transactions_attack": "Failed",
        "num_transactions_real": "Passed",
        "num_transactions_unfinished": "Unfinished",
        "num_successful_transactions": "Passed",
        "num_failed_transactions": "Failed"
    };

    if (param in qualifiedParamNameMap) {
        return qualifiedParamNameMap[param]
    }

    return param;
}

export function getQualifiedServiceName(service_name) {
    const qualifiedServiceNameMap = {
        "veridoc": "Document recognition",
        "veriface": "Face recognition",
        "verilive": "Liveness detection"
    };

    if (service_name in qualifiedServiceNameMap) {
        return qualifiedServiceNameMap[service_name];
    }

    return service_name;
}

export function getPreviewServiceIcon(service_name) {
    const previewIconMap = {
        "veridoc": VeridocIcon,
        "veriface": VerifaceIcon,
        "verilive": VeriliveIcon
    }

    return previewIconMap[service_name];
}